import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import "./unidades.css";
import Sidebar from '../../components/Sidebar';
import RegisterEquipments from '../Unidades/registerEquipments';
import RegisterCell from './registerCell';
import EditUnit from './editUnit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { useUnits } from '../../context/unitsContext';
import Modal from '../../components/modal';
import Header from '../../components/header';
import Lapis from '../../assets/icons/lapis.svg';
import PlusCircle from '../../assets/icons/pluscircle.svg';
import VisibleAccess from '../../permissions/VisibleAccess';
import useSubmitLock from '../../utils/useSubmitLock';
import { toast } from 'react-toastify';


function UnitDetails() {
  const {
    getUnitById,
    listPavillions,
    savePavilion,
    updatePavilion,
    listEquipments,
    updateEquipment,
    listCells,
    fetchDestination,
    fetchTypeCell,
    editCell,
  } = useUnits();

  const { unitId } = useParams();
  const [unitDetails, setUnitDetails] = useState(null);
  const [isEditUnitModalOpen, setIsEditUnitModalOpen] = useState(false);

  const [pavilions, setPavilions] = useState([]);
  const [newPavilionName, setNewPavilionName] = useState('');
  const [newPavilionOrder, setNewPavilionOrder] = useState('');
  const [selectedPavilionId, setSelectedPavilionId] = useState(null);

  const [equipments, setEquipments] = useState([]);
  const [isEquipmentModalOpen, setIsEquipmentModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [currentEquipment, setCurrentEquipment] = useState(null);


  const [cells, setCells] = useState([]);
  const [typeCell, setTypeCell] = useState([]);
  const [editCellData, setEditCellData] = useState(null);
  const [isEditCellModalOpen, setIsEditCellModalOpen] = useState(false);
  const [isCellModalOpen, setIsCellModalOpen] = useState(false);

  const [destination, setDestination] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditPavilionModalOpen, setIsEditPavilionModalOpen] = useState(false);
  const [editingPavilionName, setEditingPavilionName] = useState('');
  const [editingPavilionOrder, setEditingPavilionOrder] = useState('');

  const normalizePkValue = (value) => {
    const candidate = (
      typeof value === 'object' && value !== null
        ? (value.id ?? value.pk ?? value.value ?? '')
        : value
    );

    if (candidate === undefined || candidate === null || candidate === '') {
      return '';
    }

    const asNumber = Number(candidate);
    return Number.isNaN(asNumber) ? String(candidate) : asNumber;
  };

  const getPavilionUnitId = (pavilion) => Number(
    pavilion?.unit?.id ?? pavilion?.unit_id ?? pavilion?.unit
  );

  const getCellPavilionId = (cell) => Number(
    cell?.pavilion?.id ?? cell?.pavilion_id ?? cell?.pavilion
  );

  const resolveOptionPk = (value, options = [], labelKeys = []) => {
    const normalized = normalizePkValue(value);
    if (typeof normalized === 'number') return normalized;
    if (typeof normalized === 'string' && normalized.trim() !== '') {
      const byLabel = options.find((option) => (
        labelKeys.some((key) => (
          String(option?.[key] || '').trim().toLowerCase() === normalized.trim().toLowerCase()
        ))
      ));
      if (byLabel?.id !== undefined && byLabel?.id !== null) {
        return Number(byLabel.id);
      }
    }
    return '';
  };

  const resolveTypeCellPk = (value, fallbackCell = null) => {
    const byRaw = resolveOptionPk(value, typeCell, ['type', 'name', 'description']);
    if (byRaw !== '') return byRaw;
    const byIdField = resolveOptionPk(
      fallbackCell?.type_cell_id ?? fallbackCell?.type_cell?.id,
      typeCell,
      ['type', 'name', 'description']
    );
    return byIdField;
  };

  const resolveDestinationPk = (value, fallbackCell = null) => {
    const byRaw = resolveOptionPk(value, destination, ['name', 'description', 'type']);
    if (byRaw !== '') return byRaw;
    const byIdField = resolveOptionPk(
      fallbackCell?.destination_id ?? fallbackCell?.destination?.id,
      destination,
      ['name', 'description', 'type']
    );
    return byIdField;
  };

  const getTypeCellLabel = (cell) => {
    if (typeof cell?.type_cell === 'string' && cell.type_cell.trim()) return cell.type_cell;
    const typeId = resolveTypeCellPk(cell?.type_cell, cell);
    const option = Array.isArray(typeCell) ? typeCell.find((type) => String(type.id) === String(typeId)) : null;
    return option?.type || 'N/A';
  };

  const getDestinationLabel = (cell) => {
    if (typeof cell?.destination === 'string' && cell.destination.trim()) return cell.destination;
    const destinationId = resolveDestinationPk(cell?.destination, cell);
    const option = Array.isArray(destination) ? destination.find((dest) => String(dest.id) === String(destinationId)) : null;
    return option?.name || 'N/A';
  };

  const [currentTab, setCurrentTab] = useState('dadosGerais');
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();

  const openTab = (tabName) => {
    setCurrentTab(tabName);
  };

  const handlePavilonsModal = () => {
    setIsModalOpen(true);
  };

  const handleEquipmentModal = () => {
    setIsEquipmentModalOpen(true);
  };

  const handleCellModal = (pavilionId) => {
    setSelectedPavilionId(pavilionId);
    setIsCellModalOpen(true);
  };

  const handleEditCellModal = (cell) => {
    setEditCellData({
      ...cell,
      order: cell?.order ?? '',
      type_cell: resolveTypeCellPk(cell?.type_cell, cell),
      destination: resolveDestinationPk(cell?.destination, cell),
    });
    setIsEditCellModalOpen(true);
  };

  const openEditModal = () => {
    setIsEditUnitModalOpen(true);
  };

  const handleEditClick = (equipment) => {
    setCurrentEquipment(equipment);
    setIsEditModalOpen(true);
  };

  // Dados dos tipo de cela e destino
  useEffect(() => {
    const fetchData = async () => {
      try {
        const typeCellData = await fetchTypeCell();
        const destinationData = await fetchDestination();

        setTypeCell(Array.isArray(typeCellData.results) ? typeCellData.results : []);
        setDestination(Array.isArray(destinationData.results) ? destinationData.results : []);
      } catch (error) {
        console.error('Erro ao buscar tipo de cela e destino:', error);
        setTypeCell([]);
        setDestination([]);
      }
    };

    fetchData();
  }, [fetchTypeCell, fetchDestination]);


  // Listar Pavilhões
  const fetchPavilions = useCallback(async () => {
    const response = await listPavillions({ unit: unitId });
    if (response && Array.isArray(response.results)) { // Verifica se `results` é um array
      const unitIdNumber = Number(unitId);
      const pavilionsForUnit = response.results.filter(
        (pavilion) => getPavilionUnitId(pavilion) === unitIdNumber
      );
      setPavilions(pavilionsForUnit); // Salva os pavilhões filtrados no estado
    } else {
      console.error("listPavillions não retornou um array válido", response);
      setPavilions([]); // Garante que o estado seja sempre um array vazio
    }
  }, [listPavillions, unitId]);

  // Função para buscar todos os equipamentos
  const fetchEquipments = useCallback(async () => {
    const equipmentsForUnit = await listEquipments(unitId);

    if (equipmentsForUnit && Array.isArray(equipmentsForUnit)) {
      setEquipments(equipmentsForUnit); // Salva os equipamentos no estado
    } else {
      setEquipments([]); // Garante que o estado seja um array vazio
    }
  }, [listEquipments, unitId]);

  useEffect(() => {
    fetchEquipments();
    fetchPavilions();
  }, [fetchEquipments, fetchPavilions]);


  // Editar status do equipamento
  const handleEditSave = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      try {
        const updatedStatus = e.target.status.value; // Captura o novo status

        const updateSuccess = await updateEquipment(currentEquipment.id, updatedStatus);

        if (updateSuccess) {
          setIsEditModalOpen(false); // Fecha o modal
          fetchEquipments(); // Atualiza a lista
        }
      } catch (error) {
        console.error('Erro ao salvar status do equipamento:', error.message);
      }
    });
  };

  // função para listar celas
  const fetchCells = useCallback(async (pavilionIdParam) => {
    const pavilionId = pavilionIdParam ?? selectedPavilionId;
    const selectedPavilionIdNumber = Number(pavilionId);

    if (!selectedPavilionIdNumber) {
      setCells([]);
      return;
    }

    const response = await listCells({ pavilion: selectedPavilionIdNumber });

    if (response && Array.isArray(response.results)) {
      const filteredCells = response.results.filter(
        (cell) => getCellPavilionId(cell) === selectedPavilionIdNumber
      );
      setCells(filteredCells);
    } else {
      console.error("listCells não retornou um array válido", response);
      setCells([]);
    }
  }, [listCells, selectedPavilionId]);

  useEffect(() => {
    if (selectedPavilionId) {
      fetchCells(selectedPavilionId);
    }
  }, [selectedPavilionId, fetchCells]);

  // Função de editar cela
  const handleEditCell = async (cellId, updatedCellData) => {
    await runWithSubmitLock(async () => {
      const normalizedTypeCell = resolveTypeCellPk(updatedCellData?.type_cell, updatedCellData);
      const normalizedDestination = resolveDestinationPk(updatedCellData?.destination, updatedCellData);

      if (normalizedTypeCell === '' || normalizedDestination === '') {
        console.error('Falha ao normalizar type_cell/destination para edição de cela', updatedCellData);
        toast.warning('Selecione o tipo e destino da cela novamente.');
        return;
      }

      const payload = {
        name: updatedCellData?.name,
        capacity: updatedCellData?.capacity === '' ? '' : Number(updatedCellData?.capacity),
        order: updatedCellData?.order === '' ? '' : Number(updatedCellData?.order),
        bathroom: Boolean(updatedCellData?.bathroom),
        bathroom_use: Boolean(updatedCellData?.bathroom_use),
        pavilion: Number(updatedCellData?.pavilion ?? selectedPavilionId),
        type_cell: normalizedTypeCell,
        destination: normalizedDestination,
      };

      const UpdateCellsuccess = await editCell(cellId, payload);

      if (UpdateCellsuccess) {
        setIsEditCellModalOpen(false);
        fetchCells(selectedPavilionId);
      }
    });
  };

  // Detalhes da unidade
  const fetchUnitDetails = useCallback(async () => {
    const data = await getUnitById(unitId);
    if (data) {
      setUnitDetails(data);
    }
  }, [unitId, getUnitById]);

  useEffect(() => {
    fetchUnitDetails();
  }, [fetchUnitDetails]);

  // Formatar data
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('pt-BR');
  }


  // Função para adicionar novo pavilhão
  const handleAddPavilion = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      const saveNewPavilion = await savePavilion({
        name: newPavilionName,
        order: Number(newPavilionOrder),
        unit: parseInt(unitId)
      });

      if (saveNewPavilion) {
        // Atualizar a lista de pavilhões após o cadastro
        fetchPavilions();

        setIsModalOpen(false);
        setNewPavilionName('');
        setNewPavilionOrder('');
      }
    });
  };

  const handleOpenEditPavilion = () => {
    const pavilion = pavilions.find((p) => p.id === selectedPavilionId);
    setEditingPavilionName(pavilion?.name || '');
    setEditingPavilionOrder(pavilion?.order ?? '');
    setIsEditPavilionModalOpen(true);
  };

  const handleSaveEditPavilion = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      const saved = await updatePavilion(selectedPavilionId, {
        name: editingPavilionName,
        order: Number(editingPavilionOrder),
      });
      if (saved) {
        setIsEditPavilionModalOpen(false);
        fetchPavilions();
      }
    });
  };

  useEffect(() => {
    if (pavilions.length > 0 && !selectedPavilionId) {
      setSelectedPavilionId(pavilions[0].id);
    }
  }, [pavilions, selectedPavilionId]);

  return (
    <div>
      <Sidebar />
      <Header />
      <div className='container social-container admission-page'>
        <div className="admission-header">
          <div className="admission-title">
            <h2>Unidade</h2>
            <p>Informações gerais, pavilhões e equipamentos de segurança.</p>
          </div>
        </div>
        <div className="tab">
          <button className={currentTab === 'dadosGerais' ? 'active' : ''} onClick={() => openTab('dadosGerais')}>Dados Gerais</button>
          <button className={currentTab === 'pavilhoes' ? 'active' : ''} onClick={() => openTab('pavilhoes')}>Pavilhões</button>
          <button className={currentTab === 'equipments' ? 'active' : ''} onClick={() => openTab('equipments')}>Equipamentos de segurança</button>
        </div>

        <div id="dadosGerais" className={`tabcontent ${currentTab === 'dadosGerais' ? 'active' : ''}`}>
          <VisibleAccess compareField="groups" compareValues={["GERENTE DE UNIDADE", "DIRETORES", "DUAP", "ADMINISTRATIVO"]}>
            <div className='admission-actions'>
              <button onClick={openEditModal} className='btnAdcionar'>
                <img src={Lapis} alt='icone' className='icon' /> Editar unidade
              </button>
            </div>
          </VisibleAccess>

          {unitDetails ? (
            <>
              <div className='health-card unit-details-grid'>
                <h4 className='h4-title'>Dados gerais</h4>
                <div className='health-grid-two'>
                  <div className='health-option-set'>
                    <span className="health-subtitle">Nome</span>
                    <p>{unitDetails.name || '-'}</p>
                  </div>
                  <div className='health-option-set'>
                    <span className="health-subtitle">Sigla</span>
                    <p>{unitDetails.acronym || '-'}</p>
                  </div>
                  <div className='health-option-set'>
                    <span className="health-subtitle">Email</span>
                    <p>{unitDetails.institutional_email || '-'}</p>
                  </div>
                  <div className='health-option-set'>
                    <span className="health-subtitle">Orgão</span>
                    <p>{unitDetails.agency === 1 ? 'SEJUS' : '-'}</p>
                  </div>
                  <div className='health-option-set'>
                    <span className="health-subtitle">Gênero</span>
                    <p>{unitDetails.original_destination || '-'}</p>
                  </div>
                  <div className='health-option-set'>
                    <span className="health-subtitle">Estado</span>
                    <p>{unitDetails.state_name || '-'}</p>
                  </div>
                  <div className='health-option-set'>
                    <span className="health-subtitle">Cidade</span>
                    <p>{unitDetails.city_name || '-'}</p>
                  </div>
                  <div className='health-option-set'>
                    <span className="health-subtitle">Endereço</span>
                    <p>{unitDetails.address || '-'}</p>
                  </div>
                  <div className='health-option-set'>
                    <span className="health-subtitle">Telefone</span>
                    <p>{unitDetails.phone || '-'}</p>
                  </div>
                  <div className='health-option-set'>
                    <span className="health-subtitle">Tipo</span>
                    <p>{unitDetails.type_of_establishment || '-'}</p>
                  </div>
                </div>
              </div>

              <div className='health-card unit-details-grid'>
                <h4 className='h4-title'>Outros dados</h4>
                <div className='health-grid-two'>
                  <div className='health-option-set'>
                    <span className="health-subtitle">Tipo de Gestão</span>
                    <p>{unitDetails.establishment_management || '-'}</p>
                  </div>
                  <div className='health-option-set'>
                    <span className="health-subtitle">Data de Abertura</span>
                    <p>{unitDetails.opening_date ? formatDate(unitDetails.opening_date) : '-'}</p>
                  </div>
                  <div className='health-option-set'>
                    <span className="health-subtitle">Acessibilidade</span>
                    <p>{unitDetails.accessibility ? 'Sim' : 'Não'}</p>
                  </div>
                  <div className='health-option-set'>
                    <span className="health-subtitle">Regimento Interno</span>
                    <p>{unitDetails.internal_regulations ? 'Sim' : 'Não'}</p>
                  </div>
                  <div className='health-option-set'>
                    <span className="health-subtitle">Regimento</span>
                    <p>{unitDetails.own_internal_regime ? 'Próprio' : 'Geral'}</p>
                  </div>
                  <div className='health-option-set'>
                    <span className="health-subtitle">Serviços terceirizados</span>
                    <p>
                      {unitDetails?.third_party_services?.length > 0
                        ? unitDetails.third_party_services.map(service => service.type).join(', ')
                        : "Nenhum serviço terceirizado"
                      }
                    </p>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <p>Carregando...</p>
          )}

        </div>

        <div id="pavilhoes" className={`tabcontent ${currentTab === 'pavilhoes' ? 'active' : ''}`}>
          <div>
            <div className='admission-actions'>
              <VisibleAccess compareField="groups" compareValues={["GERENTE DE UNIDADE", "DIRETORES", "DUAP", "ADMINISTRATIVO"]}>
                <button className='btnAdcionar' onClick={handlePavilonsModal}>
                  <img src={PlusCircle} alt='Incone' /> Adicionar pavilhão
                </button>
              </VisibleAccess>
            </div>
            <div className='tab unit-tabs'>
              {pavilions.map(pavilion => (
                <div key={pavilion.id} style={{ display: 'flex', alignItems: 'center' }}>
                  <button className={selectedPavilionId === pavilion.id ? 'active' : ''} onClick={() => setSelectedPavilionId(pavilion.id)}>
                    {pavilion.name}
                  </button>
                  {selectedPavilionId === pavilion.id && (
                    <VisibleAccess compareField="groups" compareValues={["GERENTE DE UNIDADE", "DIRETORES", "DUAP", "ADMINISTRATIVO"]}>
                      <button
                        className='btnEditar'
                        onClick={handleOpenEditPavilion}
                        title="Editar nome do pavilhão"
                        style={{ margin: 0, padding: '0 4px', fontSize: 13, color: 'var(--texto-destaque)' }}
                      >
                        <FontAwesomeIcon icon={faPencilAlt} />
                      </button>
                    </VisibleAccess>
                  )}
                </div>
              ))}
            </div>

            {/* Renderizar os detalhes do pavilhão selecionado */}
            {selectedPavilionId && (
              <div>
                {/* Tabela das celas */}
                <div className='content-table'>
                  <table>
                    <thead>
                      <tr>
                        <th>Nome</th>
                        <th>Ordem</th>
                        <th>Capacidade</th>
                        <th>Tipo de cela</th>
                        <th>Destino</th>
                        <th>Banheiro</th>
                        <th>Banheiro em uso</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {cells &&
                        Array.isArray(cells) &&
                        cells.map((cell) => (
                          <tr key={cell.id}>
                            <td>{cell.name}</td>
                            <td>{cell.order}</td>
                            <td>{cell.capacity}</td>
                            <td>{getTypeCellLabel(cell)}</td>
                            <td>{getDestinationLabel(cell)}</td>
                            <td>{cell.bathroom ? 'Sim' : 'Não'}</td>
                            <td>{cell.bathroom_use ? 'Sim' : 'Não'}</td>
                            <td>
                              <VisibleAccess compareField="groups" compareValues={["GERENTE DE UNIDADE", "DIRETORES", "DUAP", "ADMINISTRATIVO"]}>
                                <button onClick={() => handleEditCellModal(cell)} className='btnEditar'>
                                  <FontAwesomeIcon icon={faPencilAlt} />
                                </button>
                              </VisibleAccess>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
                <VisibleAccess compareField="groups" compareValues={["GERENTE DE UNIDADE", "DIRETORES", "DUAP", "ADMINISTRATIVO"]}>
                  <div className='admission-actions'>
                    <button onClick={() => handleCellModal(selectedPavilionId)} className='btnAdcionar'>
                      <img src={PlusCircle} alt='Incone' /> Adicionar cela
                    </button>
                  </div>
                </VisibleAccess>
              </div>
            )}
          </div>
        </div>

        <div id="equipments" className={`tabcontent ${currentTab === 'equipments' ? 'active' : ''}`}>
          <div>
            <div className='admission-actions'>
              <VisibleAccess compareField="groups" compareValues={["GERENTE DE UNIDADE", "DIRETORES", "DUAP", "ADMINISTRATIVO"]}>
                <button className='btnAdcionar' onClick={handleEquipmentModal}>
                  <img src={PlusCircle} alt='Incone' /> Adicionar equipamentos
                </button>
              </VisibleAccess>
            </div>
            <div className='content-table'>
              <table>
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Status</th>
                    <VisibleAccess compareField="groups" compareValues={["GERENTE DE UNIDADE", "DIRETORES", "DUAP", "ADMINISTRATIVO"]}>
                      <th>Editar</th>
                    </VisibleAccess>
                  </tr>
                </thead>
                <tbody>
                  {equipments.map((equipment, index) => (
                    <tr key={index}>
                      <td>{equipment.name}</td>
                      <td>{equipment.status}</td>
                      <td>
                        <VisibleAccess compareField="groups" compareValues={["GERENTE DE UNIDADE", "DIRETORES", "DUAP", "ADMINISTRATIVO"]}>
                          <button onClick={() => handleEditClick(equipment)} className='btnEditar'>
                            <FontAwesomeIcon icon={faPencilAlt} />
                          </button>
                        </VisibleAccess>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>

      {/* Modal cadastro pavilhão */}
      {
        isModalOpen && (
          <Modal title={'Adicionar pavilhão'} isOpen={isModalOpen} closeModal={() => setIsModalOpen(false)}>
            <div className='unit-modal'>
              <form onSubmit={handleAddPavilion} className="unit-modal-form unit-modal-grid">
                <div className="unit-modal-field span-2">
                  <label>Nome do pavilhão</label>
                  <input
                    type="text"
                    placeholder="Digite o nome do pavilhão"
                    value={newPavilionName}
                    required
                    onChange={(e) => setNewPavilionName(e.target.value)}
                  />
                </div>
                <div className="unit-modal-field span-2">
                  <label>Ordem</label>
                  <input
                    type="number"
                    placeholder="Digite a ordem de exibição"
                    min="1"
                    value={newPavilionOrder}
                    required
                    onChange={(e) => setNewPavilionOrder(e.target.value)}
                  />
                  <small className='field-hint'>Ordem de visualização do pavilhão</small>
                </div>
                <div className="unit-modal-actions">
                  <button type="submit" className="btnConfirmar" disabled={isSubmitting}>
                    {isSubmitting ? 'Adicionando...' : 'Adicionar'}
                  </button>
                </div>
              </form>
            </div>
          </Modal>
        )
      }

      {/* Modal editar nome do pavilhão */}
      {isEditPavilionModalOpen && (
        <Modal title={'Editar pavilhão'} isOpen={isEditPavilionModalOpen} closeModal={() => setIsEditPavilionModalOpen(false)}>
          <div className='unit-modal'>
            <form onSubmit={handleSaveEditPavilion} className="unit-modal-form unit-modal-grid">
              <div className="unit-modal-field span-2">
                <label>Nome do pavilhão</label>
                <input
                  type="text"
                  placeholder="Digite o nome do pavilhão"
                  value={editingPavilionName}
                  required
                  onChange={(e) => setEditingPavilionName(e.target.value)}
                />
              </div>
              <div className="unit-modal-field span-2">
                <label>Ordem</label>
                <input
                  type="number"
                  placeholder="Digite a ordem de exibição"
                  min="1"
                  value={editingPavilionOrder}
                  required
                  onChange={(e) => setEditingPavilionOrder(e.target.value)}
                />
                <small className='field-hint'>Ordem de visualização do pavilhão</small>
              </div>
              <div className="unit-modal-actions">
                <button type="submit" className="btnConfirmar" disabled={isSubmitting}>
                  {isSubmitting ? 'Salvando...' : 'Salvar'}
                </button>
              </div>
            </form>
          </div>
        </Modal>
      )}

      {/* Modal de adicionar equipamentos */}
      {
        isEquipmentModalOpen && (
          <Modal title={'Selecione equipamentos e quantidades'} isOpen={isEquipmentModalOpen} closeModal={() => setIsEquipmentModalOpen(false)}>
            <div className='div-modal'>
              <RegisterEquipments
                unitId={unitId}
                onSaveSuccess={fetchEquipments}
                onCloseModal={() => setIsEquipmentModalOpen(false)}
              />
            </div>
          </Modal>
        )
      }

      {/* Modal de adcionar de Cela */}
      {
        isCellModalOpen && (
          <Modal title={'Adicionar nova Cela'} isOpen={isCellModalOpen} closeModal={() => setIsCellModalOpen(false)}>
            <div className='div-modal'>
              {typeCell && destination && (
                <RegisterCell
                  pavilionId={selectedPavilionId}
                  onSaveSuccess={() => fetchCells(selectedPavilionId)}
                  onCloseModal={() => setIsCellModalOpen(false)}
                  typeCell={typeCell}
                  destination={destination}
                />
              )}
            </div>
          </Modal>
        )
      }

      {/* Modalde Editar Cela */}
      {
        isEditCellModalOpen && (
          <Modal title={'Editar Cela'} isOpen={isEditCellModalOpen} closeModal={() => setIsEditCellModalOpen(false)}>
            <div className='unit-modal'>
              <form onSubmit={(e) => {
                e.preventDefault();
                handleEditCell(editCellData.id, editCellData);
              }} className="unit-modal-form unit-modal-grid">
                <div className="unit-modal-field">
                  <label htmlFor="name">Nome</label>
                  <input
                    type="text"
                    id="name"
                    maxLength={10}
                    value={editCellData.name}
                    onChange={(e) => setEditCellData({ ...editCellData, name: e.target.value })}
                  />
                </div>
                <div className="unit-modal-field">
                  <label htmlFor="capacity">Capacidade</label>
                  <input
                    type="number"
                    id="capacity"
                    min="1"
                    value={editCellData.capacity}
                    onChange={(e) => setEditCellData({ ...editCellData, capacity: e.target.value })}
                  />
                </div>
                <div className="unit-modal-field">
                  <label htmlFor="order">Ordem</label>
                  <input
                    type="number"
                    id="order"
                    min="1"
                    value={editCellData.order}
                    onChange={(e) => setEditCellData({ ...editCellData, order: e.target.value })}
                  />
                  <small className='field-hint'>Ordem de visualização da cela</small>
                </div>
                <div className="unit-modal-field">
                  <label htmlFor="type">Tipo de Cela</label>
                  <select
                    id="type"
                    value={String(normalizePkValue(editCellData.type_cell) || '')}
                    onChange={(e) => setEditCellData({ ...editCellData, type_cell: normalizePkValue(e.target.value) })}
                  >
                    {typeCell.map(type => (
                      <option key={type.id} value={type.id}>{type.type}</option>
                    ))}
                  </select>
                </div>
                <div className="unit-modal-field">
                  <label htmlFor="destination">Destino</label>
                  <select
                    id="destination"
                    value={String(normalizePkValue(editCellData.destination) || '')}
                    onChange={(e) => setEditCellData({ ...editCellData, destination: normalizePkValue(e.target.value) })}
                  >
                    {destination.map(dest => (
                      <option key={dest.id} value={dest.id}>{dest.name}</option>
                    ))}
                  </select>
                </div>
                <div className="unit-modal-field">
                  <label htmlFor="bathroom">Banheiro</label>
                  <select
                    id="bathroom"
                    value={editCellData.bathroom ? 'Sim' : 'Não'}
                    onChange={(e) => setEditCellData({ ...editCellData, bathroom: e.target.value === 'Sim' })}
                  >
                    <option value="Sim">Sim</option>
                    <option value="Não">Não</option>
                  </select>
                </div>
                <div className="unit-modal-field">
                  <label htmlFor="bathroom_use">Banheiro em uso</label>
                  <select
                    id="bathroom_use"
                    value={editCellData.bathroom_use ? 'Sim' : 'Não'}
                    onChange={(e) => setEditCellData({ ...editCellData, bathroom_use: e.target.value === 'Sim' })}
                  >
                    <option value="Sim">Sim</option>
                    <option value="Não">Não</option>
                  </select>
                </div>
                <div className="unit-modal-actions">
                  <button type="submit" className="btnConfirmar" disabled={isSubmitting}>
                    {isSubmitting ? 'Salvando...' : 'Salvar'}
                  </button>
                </div>
              </form>
            </div>
          </Modal>
        )
      }

      {/* Modal de editar unidade */}
      {
        isEditUnitModalOpen && (
          <Modal title={'Editar Unidade'} isOpen={isEditUnitModalOpen} closeModal={() => setIsEditUnitModalOpen(false)}>
            <div className='div-modal'>
              <EditUnit
                unitId={unitId}
                onSaveSuccess={fetchUnitDetails}
                onCloseModal={() => setIsEditUnitModalOpen(false)}
              />
            </div>
          </Modal>
        )
      }

      {/* Modal de Editar equipamento */}
      {
        isEditModalOpen && (
          <Modal
            title="Editar Status do Equipamento"
            isOpen={isEditModalOpen}
            closeModal={() => setIsEditModalOpen(false)}
          >
            <div className='unit-modal'>
              <form onSubmit={handleEditSave} className="unit-modal-form unit-modal-grid">
                <div className="unit-modal-field span-2">
                  <label htmlFor="status">Status</label>
                  <select name="status" defaultValue={currentEquipment?.status}>
                    <option value="Uso">Uso</option>
                    <option value="Manutenção">Manutenção</option>
                    <option value="Danificado">Danificado</option>
                  </select>
                </div>
                <div className="unit-modal-actions">
                  <button type="submit" className="btnConfirmar" disabled={isSubmitting}>
                    {isSubmitting ? 'Salvando...' : 'Salvar'}
                  </button>
                </div>
              </form>
            </div>
          </Modal>
        )
      }

    </div >
  );
}

export default UnitDetails;
